<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div class="col-md-12 mb-5">
        <div class="formdynamic_item col-md-6 py-o">
            <div class="formdynamic__item__field">
                <label class="modal-label input-date-template" v-html="`Date Range:`" />
                <date-range-picker class="d-block" ref="picker" v-model="form_data.date_range" cancelLabel="Clear">
                    <template v-slot:input="picker" style="min-width: 350px;">
                        {{ date(picker.startDate) }} - {{ date(picker.endDate) }}
                    </template>

                    <div slot="footer" slot-scope="data" class="slot p-2">
                        <span class="d-inline-block" style="margin-left: 2px; font-size: 13px; min-width: 7.5rem;">
                            {{ data.rangeText }}
                        </span>
                        <span style="margin-left: auto">
                            <a @click="clearRangeDate(data)" class="modal__buttons__item cancel">Cancel</a>
                        </span>
                        <span style="margin-left: auto">
                            <a @click="data.clickApply" v-if="!data.in_selection" class="modal__buttons__item" style="width: 4.5rem">Apply</a>
                        </span>
                    </div>
                </date-range-picker>
            </div>
        </div>
    </div>

    <div class="tab-content" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

    
        
          
          
        
    
<script>
import axios from 'axios';
import Resources from './resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "ProductivitySummaryByAssignment",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        DateRangePicker
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            title_page: 'Reports',
            rest_api: `search_standard_reports`,
            title: 'Productivity Summary By Assignment Report',
            current_url: `/reports`,
            breadcrumb: JSON.parse(JSON.stringify(Resources.breadcrumb)),
            table_headers: Resources.log_productivity_by_assignment_table_headers,
            search: '',
            first_request: true,
            pdfSource: '',
            form_data: { date_range: { startDate: "", endDate: "" }, },
            moment
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        clearRangeDate(data) {
            data.clickCancel()
            this.form_data.date_range = { startDate: null, endDate: null }
        },

        date(val) {
            return val ? moment(val).format("MM/D/YYYY") : "";
        },

        async getReport() {
            const form_data = {
                standard_report_id: 17,
                params: this.form_data,
                headers: this.table_headers,
                format: 'landscape'
            }

            this.loader(true)

            const response = await this.post('search_standard_reports', form_data)

            if (response.status) {
                const base64Data = await this.downloadFile(response, true)
                var blobUrl = URL.createObjectURL(base64Data);
                this.pdfSource = blobUrl
            } else {
                this.error_handling(response)
            }

            this.loader(false)
        },

    },

    watch: {
        async 'form_data.date_range'() {
            this.getReport()
        }
    },

    async mounted() {
        if (this.hasPermissions(['Report Read'])) {
            // const today = moment();
            // const startDate = today.format('YYYY-MM-DD') + "T05:00:00.000Z";
            // const endDate = today.format('YYYY-MM-DD') + "T16:59:59.999Z";

            // this.form_data.date_range = { startDate: '', endDate: '' }

            this.breadcrumb.push({
                name: 'Productivity Summary By Assignment',
                href: 'productivity-summary',
                arrow: '',
            }, )
        }
    },

}
</script>
